let allPlans;
if (process.env.NODE_ENV === 'development') {
  allPlans = [{
    id: 'price_1H9myGKa8WgAceKuziohc5ZO',
    name: 'Starter Plan',
    monthlyPay: 7,
    returnAvaliables: 15,
  }, {
    id: 'price_1H9mypKa8WgAceKuRlHwYlQ7',
    name: 'Plus Plan',
    monthlyPay: 29,
    returnAvaliables: 120,
  }, {
    id: 'price_1H9mzHKa8WgAceKuVfOzG32Q',
    name: 'Pro Plan',
    monthlyPay: 99,
    returnAvaliables: 500,
  }]
} else { // NOTE: production mode
  allPlans = [{
    id: 'price_1HOdg9Ka8WgAceKu3ksoP87A',
    name: 'Starter Plan',
    monthlyPay: 7,
    returnAvaliables: 15,
  }, {
    id: 'price_1HOe7lKa8WgAceKuccYyypWg',
    name: 'Plus Plan',
    monthlyPay: 29,
    returnAvaliables: 120,
  }, {
    id: 'price_1HOe94Ka8WgAceKumUA9qq6h',
    name: 'Pro Plan',
    monthlyPay: 99,
    returnAvaliables: 500,
  }]
}

export { allPlans };
